import 'mobile-angular-ui/dist/css/mobile-angular-ui-base.css';
import 'mobile-angular-ui/dist/css/mobile-angular-ui-desktop.css';
import 'mobile-angular-ui/dist/css/mobile-angular-ui-hover.css';

import 'fastclick';
import 'imports-loader?this=>window!imports-loader?FastClick=fastclick!mobile-angular-ui/dist/js/mobile-angular-ui.js';
import 'imports-loader?this=>window!imports-loader?FastClick=fastclick!mobile-angular-ui/dist/js/mobile-angular-ui.gestures.js';
import 'mobile-detect';
